import { RoadmapAction, RoadmapActionTypes } from '@completion/actions';
import { Feature } from '@completion/models';

export interface RoadmapState {
  features: Feature[];
  selectedFeature: Feature;
  selectedActivity: any;
  loading: boolean;
  error: any;
  lastCreatedFeatureId?: number | null;
}

export const initialState: RoadmapState = {
  features: [],
  selectedFeature: null,
  selectedActivity: null,
  loading: false,
  error: null,
  lastCreatedFeatureId: null,
};

export function roadmapReducer(state: RoadmapState = initialState, action: RoadmapAction): RoadmapState {
  switch (action.type) {
    case RoadmapActionTypes.LoadFeatures:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case RoadmapActionTypes.LoadFeaturesSuccess:
      return {
        ...state,
        loading: false,
        features: action.features,
        lastCreatedFeatureId: null,
      };
    case RoadmapActionTypes.LoadFeaturesFailure:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case RoadmapActionTypes.CreateFeatureSuccess:
      return {
        ...state,
        features: [...state.features, action.feature],
        lastCreatedFeatureId: action.feature.id,
      };
    case RoadmapActionTypes.UpdateFeatureSuccess:
      return {
        ...state,
        features: state.features.map((f) => (f.id === action.feature.id ? action.feature : f)),
      };
    case RoadmapActionTypes.DeleteFeatureSuccess:
      return {
        ...state,
        features: state.features.filter((f) => f.id !== action.featureId),
      };

    case RoadmapActionTypes.CreateActivitySuccess:
      return {
        ...state,
        features: state.features.map((f) =>
          f.id === action.featureId ? { ...f, activities: [...(f.activities || []), action.activity] } : f,
        ),
      };
    case RoadmapActionTypes.UpdateActivitySuccess:
      return {
        ...state,
        features: state.features.map((f) =>
          f.id === action.featureId
            ? {
                ...f,
                activities: (f.activities || []).map((a) => (a.id === action.activity.id ? action.activity : a)),
              }
            : f,
        ),
      };
    case RoadmapActionTypes.DeleteActivitySuccess:
      return {
        ...state,
        features: state.features.map((f) =>
          f.id === action.featureId
            ? {
                ...f,
                activities: (f.activities || []).filter((a) => a.id !== action.activityId),
              }
            : f,
        ),
      };

    default:
      return state;
  }
}
